//react
import React, { Component } from 'react';

//components
import Materials from '../../../components/materials/materials';
import Translation from '../../../components/translation/translation';

//data
import dataTranslations from './translations.json';

class HcpTrainingMaterials extends Component {
	render() {
		const culture = this.props.culture;

		return (
			<div className="content-page__content">
				<h1><Translation culture={culture} data={dataTranslations} name="title" /></h1>
				<p><Translation culture={culture} data={dataTranslations} name="body" /></p>

				<Materials culture={culture} data={dataTranslations} name="materials1" />

				<Materials culture={culture} data={dataTranslations} name="materials2" />
			</div>
		);
	}
}

export default HcpTrainingMaterials;



// WEBPACK FOOTER //
// ./src/content/hcp/trainingMaterials/trainingMaterials.js